module.exports = __webpack_public_path__ + "resources/images/studielink-57c26bde67dd8d2999b03cf9318b5df0-cache.png";